export const getFilePreview = ({ file, url, type, name }) => {
  // API URL
  if (url) {
    type = type?.toLowerCase();
    return {
      url,
      type: type || "",
      name: name || "",
      // isImage: type?.startsWith("image/"),
      isImage: ["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(type),
      isPdf: type === "pdf",
      isVideo: ["mp4", "webm", "ogg"].includes(type),
      isOffice: ["doc", "docx", "xls", "xlsx", "xlsm", "ppt", "pptx"].includes(
        type,
      ),
    };
  }

  // Local File
  if (file) {
    const previewUrl = URL.createObjectURL(file);

    return {
      url: previewUrl,
      type: file.type,
      name: file.name,
      isImage: file.type.startsWith("image/"),
      isPdf: file.type === "application/pdf",
      isVideo: file.type.startsWith("video/"),
      isOffice: [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ].includes(file.type),
    };
  }

  return null;
};

export const revokeFilePreview = (preview) => {
  if (preview?.url?.startsWith("blob:")) {
    URL.revokeObjectURL(preview.url);
  }
};
